import { Clinic } from "@relieftelemed/platform";

export const clinicInitials = (clinic: Clinic): string =>
  clinic.name
    .split(" ")
    .map((segment: string) => {
      return segment.substr(segment.indexOf("#") + 1, 1);
    })
    .join("");
